export const statuses = [
  {
    id: '1',
    name: '有効'
  },
  {
    id: '0',
    name: '無効'
  },
]